<template>
  <v-container fluid class="pa-0">
    <picture>
      <source media="(max-width: 480px)" srcset="../assets/bg_sp.jpg" />
      <img :src="BgImg" class="responsive-img" />
    </picture>
    <About />
    <v-row justify="center" class="mx-3">
      <v-col cols="12" md="6">
        <LinkButton
          link-url="stream.html"
          link-text="実況・動画配信ガイドライン"
          :isBlank="true"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="mx-3">
      <v-col cols="12" md="6">
        <LinkButton link-url="/dlc" link-text="ダウンロードコンテンツ" />
      </v-col>
    </v-row>
    <SS />
    <ProductPage />
  </v-container>
</template>

<script>
  import image1 from "../assets/bg.jpg";
  import About from "./AboutGame.vue";
  import LinkButton from "./AnyButton.vue";
  import ProductPage from "./SoftProduct.vue";
  import SS from "./ScreenShot.vue";

  export default {
    name: "TopPage",
    data: () => ({
      BgImg: image1,
    }),
    components: {
      About,
      LinkButton,
      ProductPage,
      SS,
    },
  };
</script>
<style scoped>
  .bold {
    color: #ff1744;
    font-weight: bold;
  }
  .responsive-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
